import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, vModelText as _vModelText, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-fd877f6c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "auxbanner" }
const _hoisted_2 = {
  key: 0,
  class: "moveTask-header"
}
const _hoisted_3 = { class: "moveTaskTitle" }
const _hoisted_4 = { class: "moveTaskSubTitle" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "divider" }, null, -1))
const _hoisted_6 = { class: "moveFrom" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Prosjektet har ingen eier", -1))
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = { key: 1 }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Flytt fra firma:", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Eier: ", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Ny eier: ", -1))
const _hoisted_16 = { class: "userContent" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", { class: "moveTo" }, "Velg bruker:", -1))
const _hoisted_18 = ["disabled"]
const _hoisted_19 = {
  key: 0,
  class: "userContainer"
}
const _hoisted_20 = ["onClick"]
const _hoisted_21 = { class: "userContent-username" }
const _hoisted_22 = { class: "button-container" }
const _hoisted_23 = /*#__PURE__*/_createTextVNode("Flytt prosjekt")
const _hoisted_24 = /*#__PURE__*/_createTextVNode("Flytt prosjekter")
const _hoisted_25 = /*#__PURE__*/_createTextVNode("Avbryt")

import { computed, ComputedRef, onBeforeMount, reactive, ref } from 'vue';
import { AuxButton, AuxCard, AuxBanner, AuxSpinner } from '@ambita/design-system';
import { useRoute } from 'vue-router';
import APIServices from '@/services/apiFetch';
import { TaskTypes } from '@/typings/task/task';
import { UserType } from '@/typings/User/user';
import SearchAndSelect from '@/components/SearchAndSelectList/SearchAndSelect.vue';
import { RouterService } from '@/router';
import UserInfo from '@/components/Cards/UserCard/UserInfo.vue';
import WithdrawApplication from './WithdrawApplication.vue';
import { Common } from '@/typings/Common';


export default /*#__PURE__*/_defineComponent({
  __name: 'MoveTaskCard',
  setup(__props) {

const route = useRoute();

let isLoading = ref<boolean>(true);

// if route is /Task
let fetchedUser = ref<TaskTypes.TaskOwner | null>();
let task = ref<TaskTypes.Task | null>();

// if coming from User
let tasks = ref<TaskTypes.Task[]>([]);

let hasOwner = ref<boolean>(false);
let fromUserCard = ref<boolean>(false);

const userFilterQuery = ref<string>('');
const companyFilterQuery = ref<string>('');
const filterActivated = ref<boolean>(false);
let usersSelectedCompany = ref<UserType.User[]>([]);

let newUser = ref<Common.newUser>({
  guid: '',
  name: '',
});

const banner = reactive<Common.Banner>({
  type: '',
  message: '',
  showBanner: false,
});

// https://vuejs.org/api/sfc-script-setup.html#top-level-await
// Can be changed to use top level await after <Suspense> is not longer experimental
onBeforeMount(async () => {
  if (route.params.taskId) {
    task.value = await APIServices.fetchTaskById(route?.params?.taskId);
    if (task.value.taskOwner) {
      hasOwner.value = true;
      fetchedUser.value = task.value.taskOwner;
    }
    isLoading.value = false;
  } else if (route.params.guid) {
    fetchedUser.value = await APIServices.fetchUserById(route.params.guid);
    tasks.value = fetchedUser.value.tasks;
    hasOwner.value = true;
    fromUserCard.value = true;
    isLoading.value = false;
  }
});

const setCompany = async function (id, name) {
  //userFilterQuery.value = '';
  companyFilterQuery.value = name;
  let fetchedUserObject = await APIServices.fetchUsersByCompanyId(id);
  usersSelectedCompany.value = fetchedUserObject[0].users;
  filterActivated.value = true;
};

const filteredUsers: ComputedRef<UserType.User[]> = computed(() => {
  let userFilter = new RegExp(userFilterQuery.value, 'i');
  return usersSelectedCompany.value.filter((el: UserType.User) => el.name.match(userFilter));
});

const setNewUser = (newUserGuid, newUsername) => {
  userFilterQuery.value = '';
  companyFilterQuery.value = '';
  usersSelectedCompany.value = [];
  newUser.value.guid = newUserGuid;
  newUser.value.name = newUsername;
};

const moveTask = async function () {
  if (!task.value) {
    throw new Error('No task found');
  }
  const taskText = `Er du sikker på at du vil flytte prosjekt ${task?.value?.taskId} fra ${fetchedUser?.value?.name} til ${newUser?.value?.name}?`;

  if (confirm(taskText)) {
    const response = await APIServices.putTask(
      task?.value?.taskId,
      fetchedUser.value?.guid,
      newUser.value.guid
    );

    banner.message = await response.json();
    response.status === 200 ? (banner.type = 'success') : (banner.type = 'error');
    banner.showBanner = true;
  } else {
    alert('Du må velge firma og bruker');
  }
};

const moveTasks = async function () {
  const tasksText = `Er du sikker på at du vil flytte samtlige prosjekter fra ${fetchedUser?.value?.name} til ${newUser?.value?.name}?`;

  if (confirm(tasksText)) {
    const response = await APIServices.putTasks(fetchedUser?.value?.guid, newUser.value.guid);
    banner.message = await response.json();
    response.status === 200 ? (banner.type = 'success') : (banner.type = 'error');
    banner.showBanner = true;
  } else {
    alert('Du må velge firma og bruker');
  }
};

const setBanner = function (status) {
  if (status === 200) {
    (banner.type = 'success'), (banner.message = 'Søknadsstatus endret til usendt');
  } else {
    (banner.type = 'error'), (banner.message = 'Noe gikk galt');
  }
  banner.showBanner = true;
};

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _withDirectives(_createElementVNode("div", _hoisted_1, [
      _createVNode(_unref(AuxBanner), {
        type: banner.type
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(banner.message), 1)
        ]),
        _: 1
      }, 8, ["type"])
    ], 512), [
      [_vShow, banner.showBanner]
    ]),
    (_unref(isLoading))
      ? (_openBlock(), _createBlock(_unref(AuxSpinner), {
          key: 0,
          class: "spinner"
        }))
      : (_openBlock(), _createBlock(_unref(AuxCard), {
          key: 1,
          class: "moveTaskContent"
        }, {
          default: _withCtx(() => [
            (!_unref(fromUserCard))
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                  _createElementVNode("h1", _hoisted_3, "Prosjekt " + _toDisplayString(_unref(task)?.taskId), 1),
                  _createElementVNode("h3", _hoisted_4, _toDisplayString(_unref(task)?.projectName), 1)
                ]))
              : _createCommentVNode("", true),
            (_unref(fromUserCard))
              ? (_openBlock(), _createBlock(UserInfo, {
                  key: 1,
                  user: _unref(fetchedUser)
                }, null, 8, ["user"]))
              : _createCommentVNode("", true),
            _hoisted_5,
            (_unref(task)?.applications?.length > 0)
              ? (_openBlock(), _createBlock(WithdrawApplication, {
                  key: 2,
                  onSetBanner: setBanner,
                  applications: _unref(task)?.applications,
                  projectName: _unref(task)?.projectName
                }, null, 8, ["applications", "projectName"]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_6, [
              (!_unref(hasOwner))
                ? (_openBlock(), _createElementBlock("p", _hoisted_7, _hoisted_9))
                : (_openBlock(), _createElementBlock("div", _hoisted_10, [
                    _hoisted_11,
                    _createTextVNode(" " + _toDisplayString(_unref(fetchedUser)?.company?.name) + " ", 1),
                    _hoisted_12,
                    _hoisted_13,
                    _createVNode(_component_router_link, {
                      to: { name: 'User', params: { guid: _unref(fetchedUser)?.guid } }
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref(fetchedUser)?.name), 1)
                      ]),
                      _: 1
                    }, 8, ["to"]),
                    _hoisted_14,
                    _hoisted_15,
                    (_unref(newUser).guid)
                      ? (_openBlock(), _createBlock(_component_router_link, {
                          key: 0,
                          to: { name: 'User', params: { guid: _unref(newUser)?.guid } }
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_unref(newUser)?.name), 1)
                          ]),
                          _: 1
                        }, 8, ["to"]))
                      : _createCommentVNode("", true)
                  ]))
            ]),
            _createVNode(SearchAndSelect, { onSetCompany: setCompany }),
            _createElementVNode("div", _hoisted_16, [
              _hoisted_17,
              _withDirectives(_createElementVNode("input", {
                class: "searchUser",
                type: "text",
                placeholder: "Søk etter bruker...",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((userFilterQuery).value = $event)),
                disabled: !filterActivated.value
              }, null, 8, _hoisted_18), [
                [_vModelText, userFilterQuery.value]
              ]),
              (filterActivated.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(filteredUsers), (users) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: "newUsers",
                        key: users?.guid,
                        onClick: ($event: any) => (setNewUser(users?.guid, users?.name))
                      }, [
                        _createTextVNode(_toDisplayString(users?.name), 1),
                        _createElementVNode("span", _hoisted_21, "(" + _toDisplayString(users?.username) + ") ", 1)
                      ], 8, _hoisted_20))
                    }), 128))
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_22, [
              (!_unref(fromUserCard))
                ? (_openBlock(), _createBlock(_unref(AuxButton), {
                    key: 0,
                    disabled: !_unref(newUser)?.guid,
                    primary: true,
                    size: "small",
                    class: "btn",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (moveTask()))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_23
                    ]),
                    _: 1
                  }, 8, ["disabled"]))
                : _createCommentVNode("", true),
              (_unref(fromUserCard))
                ? (_openBlock(), _createBlock(_unref(AuxButton), {
                    key: 1,
                    disabled: !_unref(newUser)?.guid,
                    primary: true,
                    size: "small",
                    class: "btn",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (moveTasks()))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_24
                    ]),
                    _: 1
                  }, 8, ["disabled"]))
                : _createCommentVNode("", true),
              _createVNode(_unref(AuxButton), {
                primary: false,
                size: "small",
                class: "btn",
                onClick: _cache[3] || (_cache[3] = () => _unref(RouterService).routeBack())
              }, {
                default: _withCtx(() => [
                  _hoisted_25
                ]),
                _: 1
              })
            ])
          ]),
          _: 1
        }))
  ], 64))
}
}

})